import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { forgetRecentSearchEntity } from '@/components/recent-search-store';
import { Page, PageContent, PageTitle, PageTopBar } from '@/components/ui/page-layout';
import { FetcherError } from 'utils/fetcher';

export const isHttpError = (error: unknown, ...httpStatuses: number[]): error is FetcherError =>
    error instanceof FetcherError && error.httpStatus !== undefined && httpStatuses.includes(error.httpStatus);

/**
 * Drops an entity from Recent search once the backend answers 404 for it. Only 404: a 403 can be a passing
 * authorization state, and the entry would not come back once access returns.
 */
export const useForgetNotFoundEntity = (guid: string, error: unknown) => {
    const isNotFound = isHttpError(error, 404);
    useEffect(() => {
        if (isNotFound) {
            forgetRecentSearchEntity(guid);
        }
    }, [isNotFound, guid]);
};

/** Stands in for an entity page that has nothing to show, with a way back to the entity's list. */
export const EntityUnavailable = ({
    title,
    backTo,
    backLabel,
}: {
    title: string;
    backTo: string;
    backLabel: string;
}) => (
    <Page>
        <PageTopBar />
        <PageContent className="flex flex-col items-start gap-4">
            <PageTitle>{title}</PageTitle>
            <Link className="underline" to={backTo}>
                {backLabel}
            </Link>
        </PageContent>
    </Page>
);
